import { request } from '../utils/request'
import { querystring } from '../utils/index'

export default {
  getcertificates: option => request('v1/certificate/getcertificates', option, true, false), // 查询证书列表
  getcertificate: option => request('v1/certificate/getcertificate' + querystring(option), {}, true, false), // 查询证书
  addcertificate: option => request('v1/certificate/addcertificate', option, true, false), // 新增证书
  updatecertificate: option => request('v1/certificate/updatecertificate', option, true, false), // 修改证书
  deletecertificate: option => request('v1/certificate/deletecertificate' + querystring(option), {}, true, false), // 删除证书
  addcertificatefile: option => request('v1/certificate/addcertificatefile', option, true, false), // 新增证书文件
  updatecertificatefile: option => request('v1/certificate/updatecertificatefile ', option, true, false), // 修改证书文件
  deletecertificatefile: option => request('v1/certificate/deletecertificatefile' + querystring(option), {}, true, false) // 删除证书文件
}
